
import Vue, { PropType } from 'vue';
import { RunnitNodeField, RunnitNodeRunInputValue, RUNNIT_NODE_FIELD_TYPE } from '@run-diffusion/shared';
import MenuOrBottomSheet from '@/components/base/MenuOrBottomSheet.vue';
import CfgSlider from '@/views/Runnits/RunnitSettings/Sliders/CfgSlider.vue';
import StepsSlider from '@/views/Runnits/RunnitSettings/Sliders/StepsSlider.vue';
import RunnitBaseSlider from '@/views/Runnits/RunnitSettings/Sliders/RunnitBaseSlider.vue';
import _isNil from 'lodash/isNil';

export default Vue.extend({
	name: 'SliderField',
	props: {
		field: {
			type: Object as PropType<RunnitNodeField>,
			required: true,
		},
		value: {
			type: [String, Number, Object],
			required: false,
		},
		inputValues: {
			type: Object as PropType<Record<string, RunnitNodeRunInputValue>>,
			required: true,
		},
	},
	data () {
		return {
			RUNNIT_NODE_FIELD_TYPE,
		};
	},
	computed: {
		/**
		 * The bare value, with no unit suffix and no label: those live in the
		 * tooltip and in the popover's own label row. An empty value renders
		 * nothing, matching the other chip fields.
		 */
		displayValue (): string {
			return _isNil(this.value) ? '' : `${this.value}`;
		},
	},
	methods: {
		onInput (value: any) {
			this.$emit('input', value);
		},
	},
	components: {
		MenuOrBottomSheet,
		CfgSlider,
		StepsSlider,
		RunnitBaseSlider,
	},
});
